export const StripePaymentButton = (bm, category, label, type, config) => {
  console.log('config marketplace:>> ', config);
  bm.add(type, {
    label: `<i class="webconnect-money-check"></i><div>${label}</div>`,
    category: category,
    content: `<div data-gjs-type="stripe-payment" class="stripe-payment">
    <button id="paynow" class="btn btn-primary" onclick="processPurchase(event, '${config.stripeApiKey}', '${config.projectId}')">Checkout</button>
  </div>`,
  });
};
export default (dc, label, type, config) => {
  const defaultType = dc.getType('default');
  const defaultModel = defaultType.model;
  dc.addType(type, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-money-check"></i>',
          projectId: config.projectId,
          stripeApiKey: config.stripeApiKey,
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') == type) {
            return {
              type: type,
            };
          }
        },
      },
    ),
  });
};
